{"name":"@mochabug/adaptkit","version":"1.0.0-rc.15"}